'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import AiMlFAQ from '@/components/faqs/aiml-faq';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import UnlockThePower from '@/components/home/unlock-the-power';
import ServicesOffered from '@/components/home/services-offered';
import TechnologiesTools from '@/components/home/technologies-tools';
import IndustryWiseCases from '@/components/common/industry-wise-cases';
import HireProcessAimlDev from '@/components/technologies/hire-process-aimldev';
import IntegrationsPlatforms from '@/components/technologies/integrations-platform';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroAiMl = dynamic(() => import('@/components/technologies/tech-hero-aiml'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="dark:bg-black">
                <TechHeroAiMl />
                <UnlockThePower />
                <ServicesOffered />
                <TechnologiesTools />
                <IntegrationsPlatforms />
                <IndustryWiseCases />
                <HireProcessAimlDev
                    bg="bg-black"
                    pageTitle="Our AI/ML Development Process"
                    desc="Maximize the possibilities of the newest AI/ML version. You can hire our AI/ML developers, who are competent in the technical and interactive abilities required to meet your project's objectives."
                />
                <TechnologyFaq title="FAQs for AI and ML development projects" bg="bg-aiml-faq">
                    <AiMlFAQ />
                </TechnologyFaq>
                <CaseStudies />
                <section className="">
                    <ClientTestimonials />
                </section>
                <Blog />
                <div className="section bg-primary py-100 dark:text-light dark:bg-black dark:pt-1">
                    <div className="container lg:container md:mx-auto">
                        <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                            <ContactForm />
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
